import {ExpressCheckoutController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {LinkCheckoutGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_link_checkout_data');

const context = new Context('express_checkout');

const gateway = new LinkCheckoutGateway({
    id: 'stripe_link_checkout',
    settings,
    context
});

const controller = new ExpressCheckoutController({
    context,
    gateway,
    selector: '.banner_payment_method_stripe_link_checkout'
});

controller.initialize();